export class PushAdapterSettings {
  public onActiveChanged: (value: boolean) => void;
  public onActivatableChanged: (activatable: boolean) => void;
  public onNotificationReceived: (data: any) => any;
  public onNotificationClicked: (data: any) => void;
  public onError: (type: PushAdapterErrorType, err?: any) => void;
  public getContextDefinition: () => Promise<object>;
  constructor() {}
}

export enum PushAdapterErrorType {
  UnableToSubscribeToNotificationService = 1,
  UnableToSubscribeOnWebApiEndpoint,
  UnableToUnSubscribeOnWebApiEndpoint,
  UnableToEnablePushNotifications,
  TimeoutWhileRequestingPermissions,
  ErrorInPushNotificationPlugIn,
}
